
// import React, { useState, useEffect } from 'react';
// import { styled } from '@mui/material/styles';
// import Dialog from '@mui/material/Dialog';
// import DialogTitle from '@mui/material/DialogTitle';
// import DialogContent from '@mui/material/DialogContent';
// import IconButton from '@mui/material/IconButton';
// import { FormGroup, FormControlLabel, Checkbox } from '@mui/material';
// import { getResponse, updateResponse } from './APIs';
// import ToastNotification from '../ToastContainer/ToastNotification';

// const BootstrapDialog = styled(Dialog)(({ theme }) => ({
//   '& .MuiDialogContent-root': {
//     padding: theme.spacing(2),
//   },
//   '& .MuiDialogActions-root': {
//     padding: theme.spacing(1),
//   },
//   '& .MuiDialog-paper': {
//     width: '700px',
//     maxWidth: '700px',
//     maxHeight: '700px',
//   },
// }));


import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import { FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import { getResponse, updateResponse } from './APIs';
import ToastNotification from '../ToastContainer/ToastNotification';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import {  useNavigate } from 'react-router-dom'
import { LogoutApp } from '../../../_helpers';
import { userConstants } from '../../../_constants';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiDialog-paper': {
    width: '700px',
    maxWidth: '700px',
    maxHeight: '700px',
  },
}));

const AccessModal = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const currentUser = useSelector(state => state.authentication.user);
  const [open, setOpen] = useState(false);
  const [accessData, setAccessData] = useState([""]);
  const [checkboxErrors, setCheckboxErrors] = useState({});
  const [notification, setNotification] = useState(null);
  useEffect(() => {
    // handlegetProUserProfile();
      if(currentUser && currentUser.UserProDetails){
        setAccessData(currentUser?.UserProDetails?.user_other_profile?.your_access&&JSON.parse(currentUser?.UserProDetails?.user_other_profile?.your_access)||[""])
      }
  }, [currentUser]);
  /* useEffect(() => {
    const fetchData = async () => {
      try {
        const storedId = localStorage.getItem('id');
        const response = await getResponse('api/prouser/get-userbyid/', storedId);

        if (response?.data?.success) {
          const userData = response.data.data[0];
          const accessArray = JSON.parse(userData.your_access) || [];
          setAccessData(accessArray);
        } else {
          console.log(response);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []); */

  const handleCheckboxChange = (access) => {
    const updatedAccessData = accessData.includes(access)
      ? accessData.filter((item) => item !== access)
      : [...accessData, access];

    setAccessData(updatedAccessData);
    setCheckboxErrors({});
  };

  const handleClickOpen = () => {
    setOpen(true);
    setNotification(null);

  };

  const handleClose = () => {
    setOpen(false);
    setNotification(null);

  };

  const handleSaveChanges = async (e) => {
    e.preventDefault();
    // Check if the last two checkboxes are selected
    /* if (!accessData.includes('Accès ascenseur') || !accessData.includes('Accès parking')) {
      setCheckboxErrors({
        'Accès ascenseur': !accessData.includes('Accès ascenseur'),
        'Accès parking': !accessData.includes('Accès parking'),
      });
      return; // Stop the function execution if not selected
    } else {
      setCheckboxErrors({});
    } */

    try {
      const response = await updateResponse('api/prouser/update-your_access-details', {
        your_access: accessData,
        user_id: currentUser.UserProDetails.user_other_profile.user_id,
        // Add other fields if needed
      });

      if (response.data.success) {
          setNotification({ message: 'données mises à jour avec succès', type: 'success' });
          let UserProDetails = response.data.data;
          dispatch({ type: userConstants.USER_PRO_DETAILS, UserProDetails });
          if(localStorage.getItem('user_pro')!=null){
              let getLocalUser = JSON.parse(localStorage.getItem('user_pro'));
              getLocalUser.UserProDetails = UserProDetails;
              localStorage.setItem('user_pro', JSON.stringify(getLocalUser));
          }
          setTimeout(() => {
              // window.location.reload();
              setOpen(false); // Close the dialog
          }, 2000);
      } else {
          setNotification({ message: 'Échec de la mise à jour des données.', type: 'error' });
          console.log(response);
      }
    } catch (error) {
      console.error('Error updating data:', error);
      setNotification({ message: 'An error occurred while updating access data.', type: 'error' });
    }
  };

  const handleToastClose = () => {
    setNotification(null);
  };

  return (
    <>
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={handleClickOpen}>
            <circle cx="18" cy="18" r="17.5" stroke="#27295B" />
            <path d="M19.1973 12.3902L23.6096 16.8028L14.0284 26.3844L10.0945 26.8187C9.56783 26.8769 9.12288 26.4316 9.18147 25.9049L9.61919 21.9681L19.1973 12.3902ZM26.3386 11.7333L24.2669 9.66146C23.6207 9.01519 22.5725 9.01519 21.9263 9.66146L19.9773 11.6106L24.3896 16.0231L26.3386 14.074C26.9849 13.4274 26.9849 12.3796 26.3386 11.7333Z" fill="#27295B" />
          </svg>
      <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        {notification && <ToastNotification message={notification.message} type={notification.type} onClose={handleToastClose} />}
        <DialogTitle sx={{ m: 0, p: 2, color: "#27295B", fontWeight: "bold" }} id="customized-dialog-title">
          Accès
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
           <svg xmlns="http://www.w3.org/2000/svg" width="55" height="45" viewBox="0 0 55 55" fill="none">
                <circle cx="27.5" cy="27.5" r="27.5" fill="#797979" />
                <path d="M34.0838 17.7662C34.2885 17.5497 34.5346 17.3765 34.8074 17.2568C35.0802 17.137 35.3743 17.0732 35.6722 17.0691C35.9702 17.0649 36.2659 17.1205 36.542 17.2327C36.818 17.3448 37.0688 17.5111 37.2795 17.7218C37.4902 17.9325 37.6565 18.1832 37.7686 18.4593C37.8807 18.7354 37.9363 19.0311 37.9322 19.329C37.928 19.627 37.8642 19.921 37.7445 20.1939C37.6247 20.4667 37.4515 20.7128 37.235 20.9175L30.7036 27.4491C30.695 27.4577 30.6881 27.4679 30.6834 27.4792C30.6787 27.4905 30.6763 27.5026 30.6763 27.5148C30.6763 27.527 30.6787 27.5391 30.6834 27.5504C30.6881 27.5617 30.695 27.572 30.7036 27.5806L37.235 34.1121C37.4448 34.3185 37.6117 34.5643 37.726 34.8355C37.8403 35.1066 37.8998 35.3977 37.901 35.692C37.9022 35.9863 37.8452 36.2779 37.7332 36.55C37.6211 36.8221 37.4563 37.0693 37.2483 37.2774C37.0402 37.4855 36.7931 37.6504 36.521 37.7625C36.2489 37.8746 35.9573 37.9317 35.6631 37.9305C35.3688 37.9294 35.0777 37.8699 34.8065 37.7557C34.5353 37.6415 34.2894 37.4747 34.083 37.2649L27.5516 30.7334C27.543 30.7248 27.5327 30.7179 27.5214 30.7132C27.5102 30.7085 27.4981 30.7061 27.4858 30.7061C27.4736 30.7061 27.4615 30.7085 27.4502 30.7132C27.439 30.7179 27.4287 30.7248 27.4201 30.7334L20.8887 37.2649C20.6823 37.4747 20.4365 37.6416 20.1653 37.7559C19.8942 37.8702 19.6031 37.9297 19.3088 37.9309C19.0145 37.9321 18.7229 37.8751 18.4508 37.7631C18.1787 37.651 17.9315 37.4862 17.7234 37.2782C17.5153 37.0701 17.3505 36.8229 17.2384 36.5508C17.1263 36.2788 17.0692 35.9872 17.0703 35.6929C17.0715 35.3986 17.1309 35.1075 17.2451 34.8363C17.3594 34.5651 17.5262 34.3193 17.7359 34.1129L24.2673 27.5813C24.276 27.5727 24.2828 27.5624 24.2875 27.5512C24.2922 27.5399 24.2946 27.5278 24.2946 27.5156C24.2946 27.5033 24.2922 27.4913 24.2875 27.48C24.2828 27.4687 24.276 27.4584 24.2673 27.4498L17.7359 20.9183C17.3234 20.4991 17.0933 19.934 17.0956 19.3459C17.098 18.7578 17.3326 18.1945 17.7483 17.7786C18.1641 17.3627 18.7274 17.128 19.3154 17.1255C19.9035 17.1231 20.4687 17.3531 20.8879 17.7655L27.4193 24.297C27.428 24.3056 27.4382 24.3125 27.4495 24.3172C27.4608 24.3219 27.4729 24.3243 27.4851 24.3243C27.4973 24.3243 27.5094 24.3219 27.5207 24.3172C27.532 24.3125 27.5422 24.3056 27.5509 24.297L34.0838 17.7662Z" fill="white" />
              </svg>
        </IconButton>

        <DialogContent dividers style={{ borderTop: '2px solid #D6D6D6' }}>
          <div style={{ padding: '20px' }}>
            <div className="grid grid-cols-12 items-center mt-3 sm:mt-6 p-4">
              <label className="col-span-12 text-base font-medium text-gray mb-4">Accès</label>
              <div className="col-span-12">
                <div className="  mt-3 sm:mt-3">
                  <FormGroup className="w-full">
                    <FormControlLabel
                      className="w-full"
                      control={
                        <Checkbox
                          checked={accessData.includes('Accès pour personne handicapée')}
                          onChange={() => handleCheckboxChange('Accès pour personne handicapée')}
                          name="accessPro"
                        />
                      }
                      label="Accessibilité PMR"
                    />
                    <FormControlLabel
                      className="w-full"
                      control={
                        <Checkbox
                          checked={accessData.includes('Accès ascenseur')}
                          onChange={() => handleCheckboxChange('Accès ascenseur')}
                          name="accessPro"
                        />
                      }
                      label="Accès ascenseur"
                    />
                    <FormControlLabel
                      className="w-full"
                      control={
                        <Checkbox
                          checked={accessData.includes('Accès parking')}
                          onChange={() => handleCheckboxChange('Accès parking')}
                          name="accessPro"
                        />
                      }
                      label="Accès parking"
                    />
                    {/* Add more checkboxes based on your requirements */}
                    {checkboxErrors['Accès ascenseur'] && <p className="text-red-500 mt-1"style={{color:'red'}}>Accès ascenseur est requis</p>}
                    {checkboxErrors['Accès parking'] && <p className="text-red-500 mt-1"style={{color:'red'}}>Accès parking est requis</p>}
                  </FormGroup>
                </div>
              </div>
            </div>
          </div>
          <button
            autoFocus
            onClick={(e) => { handleSaveChanges(); }}
            type="submit"
            className="font-semibold p-4 bg-primary text-lg xl:text-xl 3xl:text-2xl font-bold text-white mt-4 sm:mt-4 3xl:mt-10 px-10 py-3 3xl:h-[62px] rounded-lg transition-all duration-300 hover:bg-secondary hover:text-white"
            style={{
              backgroundColor: '#27295B',
              color: '#FFFFFF',
              padding: '10px',
              font: 'bold',
              fontWeight: 'bold',
              paddingLeft: '30px',
              paddingRight: '30px',
              borderRadius: '10px',
              float: 'right',
            }}
          >
            Enregistrer
          </button>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};

export default AccessModal;
